// (c) chaehongee. Confidential and proprietary.

import { useCallback, useState } from 'react'
import { preloadMediaSizes as preloadMediaSizesImpl } from './imagePreload'

export interface ImageSize { w: number; h: number }

export interface UseImageSizesResult {
    imageNaturalSize: ImageSize | null
    setImageNaturalSize: (v: ImageSize | null) => void
    imageSizesBySrc: Record<string, ImageSize>
    handleImageLoad: (src?: string) => (e: React.SyntheticEvent<HTMLImageElement, Event>) => void
    handleVideoLoad: (src?: string) => (e: React.SyntheticEvent<HTMLVideoElement, Event>) => void
    preloadMediaSizes: (items: Array<{ src: string; mediaType?: string }>) => Promise<void>
}

export function useImageSizes(): UseImageSizesResult {
    const [imageNaturalSize, setImageNaturalSize] = useState<ImageSize | null>(null)
    const [imageSizesBySrc, setImageSizesBySrc] = useState<Record<string, ImageSize>>({})

    const handleImageLoad = useCallback((src?: string) => (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        const img = e.currentTarget
        const size = { w: img.naturalWidth, h: img.naturalHeight }
        if (src) {
            setImageSizesBySrc((prev) => ({ ...prev, [src]: size }))
        }
        setImageNaturalSize(size)
    }, [])

    const handleVideoLoad = useCallback((src?: string) => (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
        const video = e.currentTarget
        const size = { w: video.videoWidth, h: video.videoHeight }
        if (src) {
            setImageSizesBySrc((prev) => ({ ...prev, [src]: size }))
        }
        setImageNaturalSize(size)
    }, [])

    const preloadMediaSizes = useCallback(async (items: Array<{ src: string; mediaType?: string }>) => {
        const sizes = await preloadMediaSizesImpl(items)
        if (Object.keys(sizes).length === 0) return
        setImageSizesBySrc((prev) => ({ ...prev, ...sizes }))
    }, [])

    return {
        imageNaturalSize,
        setImageNaturalSize,
        imageSizesBySrc,
        handleImageLoad,
        handleVideoLoad,
        preloadMediaSizes,
    }
}

export default useImageSizes


